import { ITag } from "services/types";

export interface ITagsState {
  tags: ITag[];
  loading: boolean;
  error: Error | null;
}

const defaultState = {
  tags: [],
  loading: false,
  error: null
};

export const getDefaultTagsState = () => defaultState;
